import React, { PureComponent, ReactElement, Fragment as ReactFragment } from 'react';

import uuid from 'uuid/v4';

import { Field } from '@philips-emr/tws-components';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { any, bool, eventListener, number, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { RenderEvent } from '@philips-emr/tws-core/lib/component/types';
import { isFunction } from '@philips-emr/tws-utils';

import { HpmsDynamicContentFieldApi } from '../../api';

import './hpms-dynamic-content-field.scss';

export interface HpmsDynamicContentFieldProps {
  onDynamicContentRender: (event: RenderEvent) => void;
  entry: string,
  type: string,
  data: object,
  className?: string,
  width?: number,
  visible: boolean,
}
interface HpmsDynamicContentFieldStage {
  visible: boolean,
  width?: number,
}
@AwesomeComponent({ type: ComponentType.FORM, api: HpmsDynamicContentFieldApi })
export default class HpmsDynamicContentField extends PureComponent<HpmsDynamicContentFieldProps, HpmsDynamicContentFieldStage> {
  constructor(props: HpmsDynamicContentFieldProps) {
    super(props);
    this.state = {
      visible: props.visible,
      width: props.width,
    };
  }
  static propTypes = {
    onDynamicContentRender: eventListener,
    entry: string,
    type: string,
    data: any,
    className: string,
    width: number,
    visible: bool,
  };
  static defaultProps = {
    width: 3,
    visible: true,
  };
  renderDynamicContent(): ReactElement {
    const { onDynamicContentRender, entry, type, data, className, width } = this.props;
    const { visible } = this.state;
    let renderFn = (): ReactElement => {
      return <ReactFragment />;
    };
    if (isFunction(onDynamicContentRender)) {
      const render = (fn: () => ReactElement): void => {
        renderFn = fn;
      };
      onDynamicContentRender(
        new RenderEvent({
          data,
          entry,
          render,
          type,
        })
      );
    }
    return (
      <Field
        className={`c-hpms-dynamic-content-field ${className}`}
        entry={entry}
        hideLabel={true}
        label=""
        uuid={uuid()}
        visible={visible}
        width={width}
      >
        {renderFn()}
      </Field>
    );
  }
  render(): ReactElement | null {
    return this.renderDynamicContent();
  }
}
